import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import StartReview from "./edit";
import { FaChartGantt } from "react-icons/fa6";
import PerformanceReviews from "./index";
import { MODULE_REVIEWS } from "variables/modules";
import ViewPerformanceReview from "./view";

const performanceReviewRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Performance Reviews",
		basePath: "performance-reviews",
		mainComponent: <PerformanceReviews/>,
	    layout: "/console",
		viewComponent: <ViewPerformanceReview />,
	    // createComponent: <EditTrainingModule />,
	    editComponent: <StartReview />,	   
	    icon: <FaChartGantt className="icon-item" />,
	    subTitle:"Performance Review",
		level:5,
		moduleId: MODULE_REVIEWS,
	})
]

export default performanceReviewRoutes;